import type { AxiosAdapter } from 'axios';
import type { EnterApiConfig } from '../config';
import { createAuthHttpClient } from './auth-http';
import { createBaseHttp } from './base-http';
import { createNoAuthHttp } from './no-auth-http';
import type { EnterHttpClient } from './types';

/**
 * 领域客户端共享的纯传输依赖。
 *
 * React Provider 只创建这一层；具体领域客户端由消费它的 Hook 按需创建，避免根树
 * 为一个首屏请求静态拉入所有业务领域。
 */
export interface ApiModuleDeps {
    authHttp: EnterHttpClient;
    noAuthHttp: EnterHttpClient;
    apiBaseUrl: string;
    publicSiteBaseUrl?: string;
    socketProjectBaseUrl?: string;
}

export type EnterApiTransport = ApiModuleDeps;

/** 创建一次可被多个领域客户端复用的 HTTP 传输依赖。 */
export function createEnterApiTransport(
    config: EnterApiConfig,
    axiosAdapter?: AxiosAdapter
): EnterApiTransport {
    const baseHttp = createBaseHttp(config, axiosAdapter);
    const authHttp = createAuthHttpClient(
        baseHttp,
        config.authAdapter ?? { getAccessToken: () => null }
    );

    return {
        authHttp,
        noAuthHttp: createNoAuthHttp(baseHttp),
        apiBaseUrl: config.apiBaseUrl,
        publicSiteBaseUrl: config.publicSiteBaseUrl,
        socketProjectBaseUrl: config.socketProjectBaseUrl,
    };
}
